<script>
import { fetchPosts } from '../../calendar/api';
import { asyncDebounce } from '../../../utils/debounce.js';
import { getTranslate } from '../../../utils/translations.js';
import { getDaysInMonth, months, years } from '../utils/date-helper.js';

const translate = getTranslate(window.calendarTranslations);

export default {
    name: 'CalendarDataProvider',
    provide: {
        $t: (key) => translate(key)
    },
    async mounted() {
        this.fetchPostsDebounced = asyncDebounce(
            (date) => fetchPosts(date),
            1000
        );
        this.postItems = await this.fetchPostsDebounced();
    },
    data() {
        return {
            date: new Date(),
            postItems: [],
            fetchPostsDebounced: async () => []
        };
    },
    methods: {
        async dateChangeHandler(date) {
            if (this.date.getTime() === date.getTime()) {
                return;
            }
            this.date = date;
            this.postItems = await this.fetchPostsDebounced(this.date);
        },
        async updatePostsHandler(date) {
            this.postItems = await this.fetchPostsDebounced(date);
        }
    },
    computed: {
        dateConfig() {
            return {
                months,
                years,
                days: getDaysInMonth(this.date) || []
            };
        }
    }
};
</script>

<template>
    <div class="calendar-data-provider">
        <slot
            :date="date"
            :posts="postItems"
            :date-config="dateConfig"
            :update-date="dateChangeHandler"
            :update-posts="updatePostsHandler"
        ></slot>
    </div>
</template>
